import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { WelfaretypeController } from './welfaretype.controller';
import { WelfaretypeEntity } from './welfaretype.entity';
import { WelfaretypeService } from './welfaretype.service';


@Module({
    imports: [
        TypeOrmModule.forFeature([WelfaretypeEntity]),
    ],
    controllers:[WelfaretypeController],
    providers:[WelfaretypeService],
    exports:[WelfaretypeService],
})
export class WelfaretypeModule {}